<template>
  <kd-button icon :size="size" :type="type" @click="handleClick">
    <component :is="name" v-bind="$attrs" :fill="fill" />
  </kd-button>
</template>

<script>
export default {
  name: 'IconButton',
  props: {
    // 按钮大小
    size: {
      type: String,
      default: 'small',
      validator: (value) => ['small', 'medium', 'large'].includes(value)
    },
    // 按钮类型
    type: {
      type: String,
      default: 'light',
    },
    // 图标组件名称，必须与全局注册的组件名称一致
    name: {
      type: String,
      required: true
    },

    fill: {
      type: String,
      default: 'currentColor',
    },
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event)
    }
  },
}
</script>

<style lang="scss" scoped>
// 可以添加自定义样式
</style> 